import { render, staticRenderFns } from "./RoleSetting.vue?vue&type=template&id=9e899a1e&scoped=true"
import script from "./RoleSetting.vue?vue&type=script&lang=ts"
export * from "./RoleSetting.vue?vue&type=script&lang=ts"
import style0 from "./RoleSetting.vue?vue&type=style&index=0&id=9e899a1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e899a1e",
  null
  
)

export default component.exports